import { normalizeRecordResponse, workspaceDetailParams } from 'api';
import { client, computeHeaders } from 'queries';

export const workspaceProfileQuery = async ({ req, params, query }) => {
	const formattedParams = { ...workspaceDetailParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspaces/${params.workspaceId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};
